import Logger from "slotworks/utils/logger";

export default function log(message: string) {
    Logger.info("%c [GAME] Wrapper ", "background: #ccc; color: #fff", message);
}
